<template>
  <div class="actions-container">
    <div class="text-format-button" :class="options.isBoldDisabled ? 'disabled' : ''">
      <svg height="50" width="50" v-html="svg.boldSvg" @click="handleAction('bold')"></svg>
    </div>
    <div class="text-format-button" :class="options.isItalicDisabled ? 'disabled' : ''">
      <svg height="50" width="50" v-html="svg.italicSvg" @click="handleAction('italic')"></svg>
    </div>
    <div class="text-format-button" :class="options.isUnderlineDisabled ? 'disabled' : ''">
      <svg
        height="50"
        width="50"
        v-html="svg.underlineSvg"
        @click="handleAction('underline')"
      ></svg>
    </div>
  </div>
</template>
<script>
import boldSvg from 'assets/svg/text-formatting-section/text-formatting-bold.svg';
import italicSvg from 'assets/svg/text-formatting-section/text-formatting-italic.svg';
import underlineSvg from 'assets/svg/text-formatting-section/text-formatting-underline.svg';

export default {
  props: {
    options: {
      type: Object,
      iRequired: true
    }
  },
  data() {
    return {
      svg: {
        boldSvg,
        italicSvg,
        underlineSvg
      }
    };
  },
  methods: {
    handleAction(action) {
      const { boldCallback, italicCallback, underlineCallback } = this.options;
      switch (action) {
        case 'bold':
          if (boldCallback) {
            boldCallback();
          }
          break;
        case 'italic':
          if (italicCallback) {
            italicCallback();
          }
          break;
        case 'underline':
          if (underlineCallback) {
            underlineCallback();
          }
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-container {
  .text-format-button {
    display: inline-block;
    cursor: pointer;
    margin-right: 1em;

    &.disabled {
      opacity: 0.5;
      cursor: default;
      pointer-events: none;
    }
  }
}
</style>
